import React from 'react'
import PropTypes from 'prop-types'

export const CommentBox = props => {
  return (
    <div className="form-group">
      <label>{props.label}</label>
      <textarea
        onChange={props.handler}
        className="form-control"
        placeholder={props.placeholder}
        value={props.value}
        rows={props.row}
      />
    </div>
  )
}

CommentBox.propTypes = {
  handler: PropTypes.func,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  row: PropTypes.string,
}
